import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { Loja } from 'app/shared/models/pos/loja';
import { PosFiltroConsultaDoc } from '../../../views/pos/modelos/pos-filtro-consulta-doc.dto';
const httpOptions = {
  headers: new HttpHeaders({
    Authorization: 'Bearer ' + localStorage.getItem('token'),
    'Content-Type': 'application/json',
  }),
};


@Injectable({
  providedIn: 'root'
})
export class PosService {


  artigosParaVenda$ =  new BehaviorSubject<any[]>([]);
  terminalEmUso$ = new BehaviorSubject<any>(null);
  lojaSeleccionada$ = new BehaviorSubject<Loja | null>(null);
  codTelaSeleccionada$ = new BehaviorSubject<string | null>(null);
  localTerminalKey  = 'pos_terminal';
  baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = `${environment.apiFinancas}pos`;
  }

  getSerie(dado: any): Observable<any> {
    return this.http.post(this.baseUrl + '/series', dado, httpOptions).pipe();
  }
  getCodigoDocumento(dado: any): Observable<any> {
    return this.http.post(this.baseUrl + '/codigoDocumento', dado, httpOptions).pipe();
  }
  getArtigosPOS(idEmpresa: number) {
    return this.http.get(this.baseUrl + '/artigos/' + idEmpresa, httpOptions).pipe();
  }
  getclassificacoesArtigoFA() {
    return this.http.get(this.baseUrl + '/classificacoesArtigoFA', httpOptions).pipe();
  }

  getTiposArtigoPOS(): Observable<any> {
    return this.http.get(this.baseUrl + '/tiposArtigo', httpOptions).pipe();

  }

  getMetodosPagamentosPOS(): Observable<any> {
    return this.http.get(this.baseUrl + '/metodosPagamento', httpOptions).pipe();
  }

  getContasTerminalPOS(idterminal:number): Observable<any> {
    return this.http.get(this.baseUrl + '/contas/'+idterminal, httpOptions).pipe();
  }

  permissoesUtilizador(idUtilizador:number): Observable<any> {
    return this.http.get(this.baseUrl + '/permissoes/'+idUtilizador, httpOptions).pipe();
  }

  getClientesPOS(): Observable<any> {
    return this.http.get(this.baseUrl + '/clientes', httpOptions).pipe();
  }

  VerificarLicencaPOS(): Observable<any> {
    return this.http.get(this.baseUrl + '/licenca', httpOptions).pipe();
  }

  getDadosEmailCliente(idCiente: number): Observable<any> {
    return this.http.get(this.baseUrl + '/clientes/dadosEmail/' + idCiente, httpOptions).pipe();
  }

  getTiposDocumentosPOS(): Observable<any> {
    return this.http.get(this.baseUrl + '/tiposDocumento', httpOptions).pipe();
  }

  gravarDocumentoPOS(documento): Observable<any> {
    return this.http.post(this.baseUrl, documento, httpOptions).pipe();
  }

  imprimirVendaPOS(idDocumento: number, idTerminal: number): Observable<any> {
    return this.http.get(this.baseUrl + '/imprimirVenda/' + idDocumento + '/' + idTerminal, httpOptions).pipe();
  }
  getPOSDocumentos(filtro: PosFiltroConsultaDoc) {
      return this.http.post(this.baseUrl + '/terminais/documentos/listar', filtro);
  }

  imprimirDoc_POS_Desktop(modelo:any): Observable<any> {
    return this.http.post('http://localhost:7000/api/imprimirDoc/', modelo, httpOptions).pipe();
  }

  tecladovirtual_POS_Desktop(): Observable<any> {
    return this.http.get('http://localhost:7000/api/tecladoVirtual/', httpOptions).pipe();
  }


  openFullScreen(fullScreeOpen: boolean) {
    const body = document.querySelector('body');

    if (body) {
      if (fullScreeOpen) {
        body.requestFullscreen({navigationUI: 'hide'});
      } else {
        if(document.fullscreenElement){
          document?.exitFullscreen();
        }
      }
    }
  }

  getLocalTerminal() {
    return localStorage.getItem(this.localTerminalKey);
  }
  setLocalTerminal(value: any) {
     localStorage.setItem(this.localTerminalKey, JSON.stringify(value));
  }
  clearLocalTerminal() {
    localStorage.removeItem(this.localTerminalKey);
  }


}
